import { PublicEvents } from "../types/Events.types";
import { processEvent } from "../services/processEvent.service";
/**
 * Analytics Api: modalEvent.
 * @param {object} ModalEventParams Object with the form field event details.
 * @param {string} ModalEventParams.modalName Name of modal
 * @param {string} [ModalEventParams.modalDescription] Description of modal
 * @param {object} [customPayload] An optional payload that may be provided to send additional data with the event.
 *
 * @example
 * import { modalEvent } from "@octagon/public-analytics";
 *
 * // With NO additional payload data
 * modalEvent({
 *    modalName: "Session Timeout modal",
 *    modalDescription: "This is a session timeout modal"
 * });
 *
 * // With additional payload data
 * modalEvent(
 *    {
 *      modalName: "Session Timeout modal",
 *      modalDescription: "This is a session timeout modal"
 *    },
 *    { devSpecifiedData: "1625254612928" }
 * );
 *
 * @category Events
 */
export function modalEvent(params, customPayload) {
    if (customPayload === void 0) { customPayload = {}; }
    processEvent(PublicEvents.MODAL, params, customPayload);
}
